import { useCallback } from 'react';
import type { JOB_APPLICATION_TAB } from 'src/constants/tabs';
import { SUPPORT_BACK_BUTTON } from 'src/utils/buildHandleEnterAndSpaceKeyPress';
import { queryParamConfigMap } from 'src/utils/hooks/useQueryParamsStore';
import { useQueryParams } from 'use-query-params';
import {
  SELECTED_JOB_APPLICATION_PARAM_KEY,
  CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY,
} from '../queryParams';

interface UseDeepLinkedDetailView {
  detailedJobApplicationId?: string;
  showDeepLinkedDetailView: (props: {
    jobApplicationId: string;
    tab: JOB_APPLICATION_TAB;
  }) => void;
  closeDeepLinkedDetailView: () => void;
}

export const useDeepLinkedDetailView = (): UseDeepLinkedDetailView => {
  const [queryParams, setQueryParams] = useQueryParams(queryParamConfigMap);

  const showDeepLinkedDetailView = useCallback<
    UseDeepLinkedDetailView['showDeepLinkedDetailView']
  >(
    ({ jobApplicationId, tab }) => {
      setQueryParams(
        {
          [SELECTED_JOB_APPLICATION_PARAM_KEY]: jobApplicationId,
          [CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY]: tab,
        },
        SUPPORT_BACK_BUTTON,
      );
    },
    [setQueryParams],
  );

  const closeDeepLinkedDetailView = useCallback<
    UseDeepLinkedDetailView['closeDeepLinkedDetailView']
  >(() => {
    setQueryParams({
      [SELECTED_JOB_APPLICATION_PARAM_KEY]: undefined,
      [CANDIDATE_PROFILE_DRAWER_TAB_PARAM_KEY]: undefined,
    });
  }, [setQueryParams]);

  return {
    detailedJobApplicationId: queryParams.selected,
    showDeepLinkedDetailView,
    closeDeepLinkedDetailView,
  };
};
